export interface PasswordConfig {
  description?: string;
  length?: boolean;
  minLength?: number;
  maxLength?: number;
  whitespace?: boolean;
  characterCharacteristics?: boolean;
  digitCharacter?: boolean;
  nonAlphanumericCharacter?: boolean;
  uppercaseCharacter?: boolean;
  lowercaseCharacter?: boolean;
  numberOfDigits?: number;
  numberOfNonAlphanumerics?: number;
  numberOfUppercases?: number;
  numberOfLowercases?: number;
  alphabeticalSequence?: boolean;
  alphabeticalSequenceLength?: number;
  wrapAlphabeticalSequence?: boolean;
  numericalSequence?: boolean;
  numericalSequenceLength?: number;
  wrapNumericalSequence?: boolean;
  qwertySequence?: boolean;
  qwertySequenceLength?: number;
  wrapQwertySequence?: boolean;
  repeatCharacterRegex?: boolean;
  repeatCharacterSequenceLength?: number;
}

export interface PasswordValidationResult {
  isValid: boolean;
  errors: string[];
  warnings: string[];
  requirements: string[];
  strength?: number;
}

const ACTIVE_RULE_KEYS: (keyof PasswordConfig)[] = [
  'length',
  'whitespace',
  'characterCharacteristics',
  'digitCharacter',
  'nonAlphanumericCharacter',
  'uppercaseCharacter',
  'lowercaseCharacter',
  'alphabeticalSequence',
  'numericalSequence',
  'qwertySequence',
  'repeatCharacterRegex',
];

export function normalizePasswordConfig(data: unknown): PasswordConfig | null {
  if (!data || typeof data !== 'object') {
    return null;
  }

  const config = (Array.isArray(data) ? data[0] : data) as PasswordConfig;
  if (!config || typeof config !== 'object') {
    return null;
  }

  const hasActiveRules = ACTIVE_RULE_KEYS.some((key) => config[key] === true);
  return hasActiveRules ? config : null;
}
